import { connect } from "react-redux";
import BenchmarkPieChart from "./BenchmarkPieChart";


const mapStateToProps = (state) => ({

    fetchCantAnswerResponseApi: state.BenchmarkFilteringReducer.fetchCantAnswerResponseApi

});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkPieChart);
